<template>
    <div class="fst-CompareSearchQueries compareMain">
        <template v-if="queries.length">
            <div class="head" :class="{fixedHead: fixedHead}">
                <div>
                    <div class="title">
                        <span>{{$t('compare.parametersToCompare')}}</span>
                    </div>
                </div>
                <div v-for="(q, keyQ) in queriesToShow" :key="keyQ">
                    <template v-if="q.selectedItems">
                        <div class="title">
                            <span>{{$t('compare.variant')}} {{keyQ + 1}}</span>
                            <i class="p-1 fad fa-trash-alt linkLike" @click="deleteVariant(keyQ+1)"></i>

                        </div>
                        <div class="queryBlock variant">
                            <span class="item" v-for="(item, itKey) in q.selectedItems" :key="itKey">{{item}}</span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="title">
                            {{q.name}}
                            <i class="p-1 fad fa-trash-alt linkLike" @click="deleteVariant(keyQ)"></i>
                        </div>
                        <div class="queryBlock">
                            <div class="type">{{q.types[0]}}</div>
                            <query-widget :q="q"></query-widget>
                        </div>
                    </template>


                </div>
            </div>
            <div class="body">
                <el-collapse v-model="openTabs">
                    <el-collapse-item :name="f.id" v-for="(f, fKey) in facets"
                                      :key="fKey">
                        <template slot="title">
                            {{f.title}}
                            <el-tag size="mini" class="ml-2">{{f.items.length}}</el-tag>
                            <i class="fal fa-check ml-2 pb-1" v-if="selectedFacetIds.includes(f.id)"></i>
                        </template>
                        <div class="facetBlock">
                            <!--div class="title">{{f.title}}</div-->
                            <div class="items" v-for="(item, iKey) in f.items.filter(it => it.show)" :key="iKey">
                                <div class="item">
                                    <template v-if="isSingleMode">
                                    <span @click="handleSelectFacetItem(f,item)" class="pointer">
                                        <i class="mr-2"
                                           :class="!!isSelected(f,item) ? 'fas fa-check-square iq-text-primary' : 'far fa-square iq-text-secondary'"></i>
                                        {{item.name}}
                                    </span>
                                        <span class="ml-auto">{{item.docCount[0]}}</span>
                                    </template>
                                    <template v-else> {{item.name}}</template>
                                </div>
                                <template v-if="isSingleMode">
                                    <div class="item" v-for="(val, vKey) in item.docCount.slice(1)" :key="vKey">
                                        {{val}}
                                        <i v-if="isFacetMarkedInVariant(item, vKey)"
                                           class="fal fa-check iq-text-primary ml-2"></i>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="item" v-for="(val, vKey) in item.docCount" :key="vKey">{{val}}</div>
                                </template>
                            </div>
                            <div class="small linkLike mt-2"
                                 v-if="f.items.length > (f.offset || 0) && f.items.length > showMoreCount"
                                 @click="handleShowMore(f)">More ({{f.offset || showMoreCount}} / {{f.items.length}})
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <div class="addToComparison" v-show="selectedItems.length">
                    <el-button type="primary" plain size="large" round class="px-3" @click="handleResetSelectedItems">
                        <i class="far fa-times mr-1"></i>
                        {{$t('reset')}}
                    </el-button>
                    <el-button type="primary" size="large" round class="px-3" @click="handleAddToComparison"
                               :disabled="queries.length > 3">
                        <i class="far fa-plus mr-1"></i>
                        {{$t('compare.addToComparison')}}
                    </el-button>
                </div>
            </div>
        </template>
    </div>

</template>

<script>
    import QueryWidget from "./QueryWidget";

    export default {
        name: "CompareSearchQueries",
        components: {QueryWidget},
        props: {
            facets: {
                type: Array,
                default: () => ([])
            },
            queries: {
                type: Array,
                default: () => ([])
            },
            mode: {
                type: String,
                default: 'multiple'
            }
        },
        data() {
            return {
                showMoreCount: 10,
                showMoreStart: 0,
                openTabs: [],
                selectedItems: [],
                selectedFacetIds: [],
                fixedHead: false,
            }
        },
        computed: {
            queriesToShow() {
                return this.queries.slice(this.isSingleMode ? 1 : 0)
            },
            isSingleMode() {
                return this.mode === 'single'
            }
        },
        watch: {
            facets(newFacets) {
                if (newFacets.length) {
                    this.facets.forEach(fac => {
                        fac.items = fac.items.map((item, ind) => {
                            item.show = ind < this.showMoreCount;
                            return item
                        })
                        return fac
                    })
                    this.handleOpenTabs();
                    // this.openTabs = this.selectedFacetIds.length ? this.selectedFacetIds : ['YEAR']
                    // this.openTabs = _.map(this.facets.filter(it => (it.items || []).length), 'id')
                }
            }
        },
        mounted() {
            let self = this;
            document.removeEventListener('scroll', () => {
            });
            document.addEventListener('scroll', function () {
                self.fixedHead = window.scrollY > 180
            });
        },
        methods: {
            handleShowMore(fac) {
                fac.offset = (fac.offset || this.showMoreCount) + this.showMoreCount
                fac.items = fac.items.map((item, ind) => {
                    item.show = ind < fac.offset;
                    return item
                })
            },
            handleSelectFacetItem(f, item) {
                let selected = this.isSelected(f, item);
                if (!!selected) {
                    this.selectedItems = this.selectedItems.filter(it => !(it.facetId === f.facetId && it.type === f.type && it.value === item.value))
                } else {
                    this.selectedItems.push({facetId: f.facetId, type: f.type, value: item.value, id: f.id})
                }
                // this.selectedFacetIds = _.uniq(this.selectedFacetIds.concat(_.map(this.selectedItems, 'id')));
            },
            handleAddToComparison() {
                this.$emit('addToComparison', this.selectedItems)
                this.resetSelectedItems();
            },
            isSelected(f, item) {
                return this.selectedItems.find(it => it.facetId === f.facetId && it.type === f.type && it.value === item.value)
            },
            normalizeFacetCompareKey(val) {
                return String(val != null ? val : '').toLowerCase()
            },
            isFacetMarkedInVariant(item, vKey) {
                const selected = ((this.queriesToShow[vKey] || {}).selectedItems) || []
                if (!selected.length) {
                    return false
                }
                const ord = this.normalizeFacetCompareKey(item.valueOrd)
                const name = this.normalizeFacetCompareKey(item.name)
                return selected.some(si => {
                    const s = this.normalizeFacetCompareKey(si)
                    return s === ord || s === name
                })
            },
            isChecked(f, item, vKey, val) {
                return this.queriesToShow[vKey]?.selectedItems?.includes(val)
            },
            handleResetSelectedItems() {
                this.resetSelectedItems();
            },
            resetSelectedItems() {
                this.selectedItems = [];
            },
            deleteVariant(i) {
                this.$confirm(this.$t('compare.confirmColumnDelete'), this.$t('warning'), {
                    confirmButtonText: this.$t('yes'),
                    cancelButtonText:this.$t('no'),
                    type: 'warning'
                }).then(() => {
                    this.queries.splice(i, 1)
                    this.facets.forEach(facet => {
                        facet.items.forEach(item => {
                            item.docCount.splice(i, 1)
                            item.docCountRaw.splice(i, 1)
                        })
                    })
                }).catch(() => {
                });
            },
            handleOpenTabs() {
                let selectedFacetIds = []
                this.queries.forEach(query => {
                    selectedFacetIds = selectedFacetIds.concat(_.map(_.get(query, 'facets.requests').filter(q => {
                        return (q.values || []).length
                    }), fac => {
                        return fac.type + (fac.facetId || '')
                    }))
                })
                this.openTabs = this.selectedFacetIds = selectedFacetIds.length ? _.uniq(selectedFacetIds) : ['YEAR'];

                // console.log('selectedFacetIds', selectedFacetIds)

            },
            handleDeleteQuery() {

            }
        }
    }
</script>

<style lang="scss">
    $columnWidth: calc((80vw - 200px) / 4);

    .fst-CompareSearchQueries {

        .head {
            display: flex;
            font-size: .85rem;
            gap: 40px;

            &.fixedHead {
                position: fixed;
                background: #fff;
                z-index: 350;
                top: 0;
            }

            > div {
                flex: 0 0 $columnWidth;
            }

            .title {
                font-weight: 500;
                font-size: 1rem;
                margin: 5px;
                display: flex;
                gap: 10px;
                justify-content: space-between;

                span {
                    max-width: 280px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }

            .queryBlock {
                background: #F3F3FA;
                padding: 4px 7px;
                border-radius: 4px;

                &.variant {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 4px 6px;
                }

                .item {
                    background: #D6E3FF;
                    //color: #fff;
                    padding: 2px 4px;
                    border-radius: 4px;
                }
            }

            .type {
                font-weight: 500;
                margin-bottom: 4px;
            }


        }

        .body {
            margin-top: 10px;

            .el-collapse-item__header {
                font-size: 15px;
                font-weight: 500;
                color: $iq-color-primary;
            }

            .el-collapse {
                display: flex;
                flex-direction: column;
            }

            .el-collapse-item__wrap {
                padding: 0 11px;
            }

            .el-collapse-item__header {
                padding: 0 15px;
                margin: 0 -15px;
                background: #fafcff;

                &.is-active {
                    background: #fff;
                }
            }

            .facetBlock {

                .title {
                    font-weight: 500;
                    margin: 30px 0 5px;
                }

                .items {
                    display: flex;
                    gap: 40px;

                    .item {
                        display: flex;
                        align-items: center;
                        flex: 0 0 $columnWidth;
                        padding: 8px 0;
                        border-bottom: 1px solid $iq-border-color-base;
                        font-size: 14px;

                        i {
                            position: relative;
                            top: -2px;
                        }
                    }

                    &:last-child {
                        .item {
                            border-top: none;
                        }
                    }
                }

            }
        }

        .addToComparison {
            position: fixed;
            bottom: 0;
            left: calc((100vw - 80vw) / 2);
            border-radius: 10px;
            z-index: 300;
            background: #fff;
            padding: 5px 10px 15px 5px;
            display: inline-flex;
            gap: 1px;
        }
    }
</style>